import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "getLimit", "hasScope", "isUngated"];
import * as Scopes from 'automation-ui-template/constants/Scopes';
import { useWorkflowsCount } from 'automation-ui-template/hooks/workflowHooks';
import { useWorkflowLimitInfo } from 'automation-ui-template/hooks/limits';
import ErrorButton from 'automation-ui-template/_internal/errors/components/ErrorButton';
import ErrorBoundary from 'automation-ui-template/_internal/errors/ErrorBoundary';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export const WorkflowCreationButton = _ref => {
  let {
      children = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-marketplace.workflowCreationButton.label"
      }),
      getLimit,
      hasScope
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    totalWorkflowCount
  } = useWorkflowsCount();
  const {
    isWorkflowLimitReached,
    workflowLimit
  } = useWorkflowLimitInfo({
    hasScope,
    getLimit,
    totalWorkflowCount
  });
  const hasEditAccess = hasScope(Scopes.EDIT_WORKFLOW);

  // no access if no edit permission
  if (!hasEditAccess) {
    return /*#__PURE__*/_jsx(UITooltip, {
      "data-test-id": "workflow-creation-button-tooltip-no-edit-access",
      placement: "bottom right",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-marketplace.workflowCreationButton.disabledTooltip.createPermission"
      }),
      children: /*#__PURE__*/_jsx(UILoadingButton, Object.assign({
        "data-test-id": "workflow-creation-button-no-edit-access"
      }, buttonProps, {
        // ordering is important for props not to be overwritten
        loading: false,
        disabled: true,
        children: children
      }))
    });
  }
  // no access if portal has reached workflow limit
  else if (isWorkflowLimitReached) {
    return /*#__PURE__*/_jsx(UITooltip, {
      "data-test-id": "workflow-creation-button-tooltip-limit",
      placement: "bottom right",
      title: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-marketplace.workflowCreationButton.disabledTooltip.workflowCountLimit",
        options: {
          workflowCountLimit: workflowLimit
        }
      }),
      children: /*#__PURE__*/_jsx(UILoadingButton, Object.assign({
        "data-test-id": "workflow-creation-button-enterprise-limit"
      }, buttonProps, {
        // ordering is important for props not to be overwritten
        loading: false,
        disabled: true,
        children: children
      }))
    });
  }
  return /*#__PURE__*/_jsx(UILoadingButton, Object.assign({
    "data-test-id": "workflow-creation-button"
  }, buttonProps, {
    children: children
  }));
};
const WorkflowCreationButtonWrapper = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  boundaryName: "WorkflowCreationButton",
  renderError: () => /*#__PURE__*/_jsx(ErrorButton, {
    children: props.children || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-marketplace.workflowCreationButton.label"
    })
  }),
  children: /*#__PURE__*/_jsx(WorkflowCreationButton, Object.assign({}, props))
});
export default WorkflowCreationButtonWrapper;